<template>
    <div
        class="map-sambadrome"
        :class="computedClass + ' ' + highlightedClasses"
    >
        <map-sambadrome-horizontal
            v-if="orientation === 'horizontal'"
            :class="{ clickable, hovered }"
        />
        <map-sambadrome-vertical
            v-if="orientation === 'vertical'"
            :class="{ clickable, hovered }"
        />
    </div>
</template>

<script>
import MapSambadromeHorizontal from "./MapSambadromeHorizontal.vue";
import MapSambadromeVertical from "./MapSambadromeVertical.vue";

export default {
    components: {
        MapSambadromeHorizontal,
        MapSambadromeVertical
    },
    props: {
        location: {
            type: String,
            required: false
        },
        sector: {
            type: String,
            required: false
        },
        locationAndSector: {
            type: String,
            required: false
        },
        orientation: {
            type: String,
            required: false,
            default: "horizontal"
        },
        availables: {
            type: Array,
            required: false,
            default: () => []
        },
        highlightedItems: {
            type: Array,
            required: false,
            default: () => []
        },
        clickable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            hovered: false
        };
    },
    computed: {
        computedClass() {
            const addPrefix = arr =>
                arr
                    .filter(Boolean)
                    .map(item => "featured-" + item)
                    .join(" ");

            // Classes for location
            const locations = this.location ? this.location.split(",") : [];
            let locationClass = addPrefix(locations) || "";

            if (locationClass && this.sector) {
                locationClass += `-${this.sector}`;
            }

            // Classes for locationAndSector
            if (!this.locationAndSector) return locationClass;

            const locSec = this.locationAndSector.split(",");
            const locSecClass = addPrefix(locSec) || "";

            return [locationClass, locSecClass].filter(Boolean).join(" ");
        },
        highlightedClasses() {
            return this.highlightedItems
                .map(({ type, sector }) => "featured-" + type + "-" + sector)
                .join(" ");
        }
    },
    methods: {
        handleLocationClicked(props) {
            this.$emit("location-clicked", props);
        },
        isAvailable(location, sector) {
            return this.availables.includes(`${location}-${sector}`);
        }
    },
    mounted() {
        if (!this.clickable) return;

        const paths = document.querySelectorAll("path[data-location]");

        paths.forEach(path => {
            const { location, sector } = path.dataset;

            if (!this.isAvailable(location, sector)) {
                path.classList.add("disabled");
                return;
            }

            path.addEventListener("mouseover", () => {
                this.hovered = true;
            });
            path.addEventListener("mouseout", () => {
                this.hovered = false;
            });

            path.addEventListener("click", event => {
                this.handleLocationClicked({
                    location: event.target.dataset.location,
                    sector: event.target.dataset.sector,
                    side: event.target.dataset.side
                });
            });
        });
    }
};
</script>
